<template>
  <div>
    <h1>About</h1>
    <section class="section--left">
      <h3>Ice cream for two</h3>
      <div>This page was created by Hannes Kuhl</div>
      <div>To see more of his work go to</div>
      <a href="https://hannes.cool" target="_blank">his website</a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'About'
};
</script>

<style></style>
